import { useEffect } from 'react';

const APP_NAME = 'Atlas';

/**
 * Sets the document title for the current page with an "Atlas" suffix.
 * The final title will be "title | Atlas", or just "Atlas" if the title is empty.
 * @param title - The page-specific title (e.g., "Leads", "Job #1234 - Smith")
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
  }, [title]);
}
